// Selection logic for the property multi-select, kept out of the component so it is directly testable.
//
// MUI's multi-select onChange already hands back the whole next selection, so this takes that array
// rather than reconstructing it from "the option that changed". There is no reliable way to read the
// changed option off the array: on deselect MUI removes the entry in place and leaves the order
// alone, so the last element is some other still-selected id, or undefined when the last one is
// cleared.

export const ALL_PROPERTIES = 'all';

/** Normalises what MUI reports into the filter's own shape. Empty array means "all properties". */
export const nextPropertySelection = values => values.includes(ALL_PROPERTIES) ? [] : values;